"use strict";

var $ = require("jquery");
var uuid = require("./uuidMIT");

var MAIN_TEMPLATE = require("../html/ChangeEmail.html");

require("../style/general.scss");
require("../style/uim-widget.scss");
var common = require("./common");

function validateParams(params) {
    if (common.API_ENVIRONMENTS[params.configuration.environment] === undefined) {
        throw new Error("Unknown environment passed. Please choose dev, dev-1, qa, stg, uat, or prod");
    }
}


function UimChangeEmailWidget(params) {
    validateParams(params);
    this.element = params.element;
    this.emailPlaceholder = params.configuration.emailPlaceholder;
    this.currentPasswordPlaceholder = params.configuration.currentPasswordPlaceholder;
    this.email = params.configuration.email;
    this.apigeeKey = params.configuration.apigeeKey;
    this.id = params.configuration.id;
    this.environment = params.configuration.environment;
    this.baseUrl = common.API_ENVIRONMENTS[this.environment];
}

UimChangeEmailWidget.prototype.init = function () {
    var self = this;
    this.element.append(MAIN_TEMPLATE);

    this.emailField = $('#uim-new-email-input');
    var currentPasswordField = this.element.find("input#uim-uCurrentPassword-input");
    var changeEmailButton = this.element.find("input#uim-changeEmail-submit");
    this.fields = {
        newEmail: this.emailField,
        currentPassword: currentPasswordField
    };
    this.validationState = {
        newEmail : false,
        currentPassword : false
    };

    $("#current-email-show")[0].innerHTML = this.email;

    this.emailField[0].placeholder = this.emailPlaceholder || this.emailField[0].placeholder;
    currentPasswordField[0].placeholder = this.currentPasswordPlaceholder || currentPasswordField[0].placeholder;

    this.emailField.on("keyup", function () {
        self.operateOnEmail('keyup');
    });
    this.emailField.on("blur", function() {
        self.operateOnEmail('blur');
    });
    currentPasswordField.on("keyup blur", function(){
        var currentPasswordField = self.element.find("input#uim-uCurrentPassword-input");
        self.validationState.currentPassword = currentPasswordField[0].validity.valid;
        self.updateSubmitEnabledState();
    });
    changeEmailButton.on("click enter", function (e) {
        e.preventDefault();
        self.changeEmail({
            newEmail: self.fields.newEmail.val(),
            currentPassword: self.fields.currentPassword.val()
        });
    });

    var close = this.element.find("input#uim-close-submit");
    close.on("click close", function (e) {
        e.preventDefault();
        parent.postMessage("close", "*");
    });
};

UimChangeEmailWidget.prototype.operateOnEmail = function(event) {
    var validEmail = this.emailField[0].validity.valid;
    this.validationState.newEmail = validEmail;
    if (event === 'keyup' && validEmail) {
        common.hideElement(this.element.find("#input-errors"))
    }
    if (event === 'blur' && !validEmail) {
        common.showElement(this.element.find("#input-errors"))
    }
    this.updateSubmitEnabledState();
};

UimChangeEmailWidget.prototype.isInputValid = function() {
    return this.validationState.newEmail && this.validationState.currentPassword;
};

UimChangeEmailWidget.prototype.updateSubmitEnabledState = function() {
    if (this.isInputValid()) {
        $('#uim-changeEmail-submit').removeAttr('disabled');
    } else {
        $('#uim-changeEmail-submit').attr("disabled", "disabled");
    }
    this.clearServiceErrors();
};

UimChangeEmailWidget.prototype.clearServiceErrors = function() {
    var submitErrorsElement = $("#submit-errors");
    common.hideElement(submitErrorsElement.find("#authentication_error"));
    common.hideElement(submitErrorsElement.find("#unknown_server_error"));
};

UimChangeEmailWidget.prototype.showServiceErrors = function (status) {
    var submitErrorsElement = $("#submit-errors");
    if (status === 400) {
        common.showElement(submitErrorsElement.find("#authentication_error"));
    } else if (status === 401 || status === 403) {
        // 401 : cookie not present
        // 403 : cookie is not valid
        common.showElement(submitErrorsElement.find("#authentication_error"));
    } else {
        common.showElement(submitErrorsElement.find("#unknown_server_error"));
    }
};


UimChangeEmailWidget.prototype.changeEmail = function (params) {
    var self = this;

    $.ajax({
        method: "PATCH",
        url: this.baseUrl + "/users/" + this.id,
        xhrFields: {
            withCredentials: true
        },
        data: JSON.stringify({
            data : {
                type : "user" ,
                id : this.id ,
                attributes : {
                    username : params.newEmail
                }
            },
            meta : {
                verificationPassword : params.currentPassword
            }
        }),
        headers : {
            ApiKey : this.apigeeKey,
            "X-API-RequestId": uuid()
        }
    }).success(function(data, status) {
        common.showElement(self.element.find(".changed"));
        common.hideElement(self.element.find(".notChanged"));
        $("#uim-new-email-show")[0].innerHTML = params.newEmail;
    }).error(function (response, error) {
        self.showServiceErrors(response.status);
    });
};


module.exports = {
    createComponent: function (params) {
        var uimWidget = new UimChangeEmailWidget(params);
        uimWidget.init();

        return {
            setProperty: function () {},
            destroy: function () {
                params.element.children().remove();
            }
        };
    }
};



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/change-email.js
// module id = 1
// module chunks = 0